import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import ISe360User from '../se360users/ISe360User';
import ExportToProcountorComponentPage from './ExportToProcountorComponentPage';
import InvoiceReportComponentPage from './reports/InvoiceReportComponentPage';
import HowToInvoiceComponentPage from './manual/HowToInvoiceComponentPage';

interface IProps {
    selections: any;
    filters: any;
    list: any;
    user: ISe360User;
}

const ZentuvoInvoicingPage: React.FC<IProps> = (props: IProps) => {
    const [activeTab, setActiveTab] = useState(0);

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs value={activeTab} onChange={(event, value) => setActiveTab(value)}>
                    <Tab label="Export to Procountor" />
                    <Tab label="Reports" />
                    <Tab label="How to invoice" />
                </Tabs>
            </Box>

            {/* The export tab stays mounted so its loaded preview/state survives tab switches;
                the other tabs mount lazily on first open. */}
            <Box hidden={activeTab !== 0}>
                <ExportToProcountorComponentPage {...props} />
            </Box>
            <Box hidden={activeTab !== 1}>{activeTab === 1 && <InvoiceReportComponentPage />}</Box>
            <Box hidden={activeTab !== 2}>{activeTab === 2 && <HowToInvoiceComponentPage />}</Box>
        </Box>
    );
};

export default ZentuvoInvoicingPage;
